import { TFunction } from 'i18next';
import * as Yup from 'yup';
import { getLinksValidationSchema } from 'components/FormLinks';
import { getReportMessageValidationSchema } from 'features/wildfires/utils/getReportMessageValidationSchema';
import { Hazard } from 'features/hazards/hazard.types';

export const getValidationSchema = (
  t: TFunction,
  hazard?: Hazard,
): Yup.SchemaOf<object> =>
  Yup.object().shape({
    name: Yup.string().required(t('createEditHazard.inputs.name.required')),
    address: Yup.string().required(
      t('createEditHazard.inputs.address.required'),
    ),
    type: Yup.string()
      .required(t('createEditHazard.inputs.type.required'))
      .nullable(),
    parentGeoEvents: Yup.array(Yup.object()).min(
      1,
      t('createEditHazard.inputs.incidents.required'),
    ),
    status: Yup.string().required(t('createEditHazard.inputs.status.required')),
    reportMessage: Yup.string().when([], {
      is: () => !hazard?.id,
      then: getReportMessageValidationSchema(t),
      otherwise: Yup.string(),
    }),
    expandLinks: Yup.boolean(),
    links: getLinksValidationSchema(t),
    lat: Yup.number(),
    lng: Yup.number(),
    regions: Yup.array(Yup.object()),
  });
